import { useDisclosure, useTimeout } from '@mantine/hooks';

export const useAutoDisclosure = (timeout: number = 2000) => {
    const [opened, { open, close }] = useDisclosure(false);
    const { start } = useTimeout(() => {
        close();
    }, timeout);

    const toggle = () => {
        open();
        start();
    };

    return { opened, toggle };
};
